'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

/**
 * https://css-tricks.com/snippets/css/truncate-string-with-ellipsis/
 */ const truncateText = (options = {})=>{
    const { flexParent , maxWidth , width  } = options;
    return styled.css`
    ${flexParent ? `flex: 1;` : ''}
    ${maxWidth ? `max-width: ${typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`};` : ''}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${width ? `width: ${typeof width === 'string' ? width : `${width}px`};` : ''}
  `;
};

exports.truncateText = truncateText;
//# sourceMappingURL=text.js.map
